const SUPPORTED_LOCALES = ['en', 'fr', 'vi']

export const LOCALE_STORAGE_KEY = 'fly_dashboard_locale'

export const normalizeLocale = (locale, fallback = 'vi') => {
	return SUPPORTED_LOCALES.includes(locale) ? locale : fallback
}

export const getStoredLocale = (fallback = 'vi') => {
	if (typeof window === 'undefined' || !window.localStorage) {
		return fallback
	}

	try {
		return normalizeLocale(window.localStorage.getItem(LOCALE_STORAGE_KEY), fallback)
	} catch {
		return fallback
	}
}

export const saveStoredLocale = locale => {
	if (typeof window === 'undefined' || !window.localStorage) {
		return
	}

	const normalizedLocale = normalizeLocale(locale)
	try {
		window.localStorage.setItem(LOCALE_STORAGE_KEY, normalizedLocale)
	} catch {
		// Ignore storage failures so language switching still works in private mode.
	}
}
